module.exports = __webpack_public_path__ + "static/media/dust.49911515.png";